import { FC } from 'react'
import BaseLayout from './LayoutBase'
import { useSelector, useDispatch } from 'react-redux'
import {
  selectCrsUser,
  selectCrsUserInitials,
  selectCrsFullName,
  selectCrsToken,
} from '@client-hub/store/slices/metadata/selectors'
import { useUserLogoutMutation } from '@client-hub/store/api/crs/react'
import { useCcsLinks, useCrsLinks } from '@client-hub/shared/react/hooks/links'
import { BASE } from '@client-hub/shared/constants/routes'
import ROUTES from '@client-hub/shared/constants/routes'
import { crsApi } from '@client-hub/store/api/crs/react'
import { ccsApi } from '@client-hub/store/api/ccs/react'

const RootLayout: FC = () => {
  const dispatch = useDispatch()
  const user = useSelector(selectCrsUser)
  const name = useSelector(selectCrsFullName)
  const token = useSelector(selectCrsToken)
  const initials = useSelector(selectCrsUserInitials)
  const [logout] = useUserLogoutMutation()
  const crsLinks = useCrsLinks()
  const ccsLinks = useCcsLinks()
  const links = [...crsLinks, ...ccsLinks]

  const handleLogout = () => {
    logout({ token: token! }).then(() => {
      // Reset related API(s)
      dispatch(ccsApi.util.resetApiState())
      dispatch(crsApi.util.resetApiState())
    })
  }

  return (
    <BaseLayout
      header={{
        user: user ? { profilePic: user.member.profile_pic, initials, name, isAdmin: user.is_admin } : undefined,
        onLogout: handleLogout,
        myProfileLink: ROUTES.USERS.MY_PROFILE,
      }}
      sidebar={{ links }}
      basePath={BASE}
    />
  )
}

export default RootLayout
